import { render, staticRenderFns } from "./AskQuestionForm.vue?vue&type=template&id=e5b889be&scoped=true&"
import script from "./AskQuestionForm.vue?vue&type=script&lang=js&"
export * from "./AskQuestionForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e5b889be",
  null
  
)

export default component.exports